import React from 'react';

import { ApolloProvider } from '@apollo/client';

import Card from '@/components/Card';
import ReactivationOTPFlowContainer from '@/components/ReactivationFlowContainer/ReactivationOTPFlowContainer';

interface ReactivationFlowProps {
  client: any;
  onBackToLogin: () => void;
  className?: string;
}

export const ReactivationFlow: React.FC<ReactivationFlowProps> = ({ client, onBackToLogin, className }) => (
  <Card className={className}>
    <ApolloProvider client={client}>
      <ReactivationOTPFlowContainer backToLogin={onBackToLogin} />
    </ApolloProvider>
  </Card>
);
